import { CarsState } from '../../types';

import { carsActions } from '../reducer';

export const updateVisibilityEBoxLocations = (
  show: CarsState['eBoxLocations']['show']
) => carsActions.setVisibilityEBoxLocations(show);
